// extracted by mini-css-extract-plugin
export default {"container":"WM-z","modal":"XM-z","dimensions":"YM-z","brandName":"ZM-z","productName":"_M-z","labelValue":"aN-z","recipientEmail":"bN-z","recommendedFit":"cN-z","hiddenField":"dN-z"};